import React from "react";

// One-line labeled text input used by ComposeDialog for To/Cc/Bcc/Subject.
export default function Row({ label, value, onChange, testId, placeholder }) {
    return (
        <div className="flex items-center gap-2">
            <label className="w-14 text-[10px] uppercase tracking-[0.18em] text-slate-400 font-bold shrink-0">{label}</label>
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                data-testid={testId}
                className="flex-1 bg-[#05091A] border border-[#2A3655] rounded-sm px-3 py-2 text-sm text-white placeholder:text-slate-600 focus:outline-none focus:border-[#00A3FF]"
            />
        </div>
    );
}
